import { Injectable } from '@angular/core';
import { Report } from './report';



@Injectable()
export class ReportsService {



    getReports(): Report[] {
        return REPORTS;
    }
    getReport(): Report {
        return REPORTS[1];
    }

    getNboriginalPictures(): number {
        return REPORTS[1].originalPictures.length;
    }
    getNbtransformedPictures(): number {
        return REPORTS[1].transformedPictures.length;
    }
    getNbnotSentPictures(): number {
        return REPORTS[1].notSentPictures.length;
    }

}

export const REPORTS: Report[] =
    [{
        originalPictures: ["originalPicture1.jpg", "originalPicture2.jpg", "originalPicture3.jpg"],
        transformedPictures: ["transformedPicture1.jpg", "transformedPicture2.jpg", "transformedPicture3.jpg"],
        notSentPictures: ["notSentPictures1.jpg", "notSentPictures2.jpg", "notSentPictures3.jpg"],
        html: "to do html..."
    },
    {
        originalPictures: ["originalPicture1.jpg", "originalPicture2.jpg", "originalPicture3.jpg"],
        transformedPictures: [],
        notSentPictures: [],
        html: "to do html..."
    }
        ,
    {
        originalPictures: ["originalPicture1.jpg", "originalPicture2.jpg", "originalPicture3.jpg"],
        transformedPictures: ["transformedPicture1.jpg", "transformedPicture2.jpg", "transformedPicture3.jpg"],
        notSentPictures: [],
        html: "to do html..."
    }


    ];

